import React from "react";
import Cards_2 from "../cards/2/Cards";
import Cards_1_3 from "../cards/1-3/Cards";
import Cards_1_2_2 from "../cards/1-2-2/Cards" 
import BannerCarousel from "../carousels/BannerCarousel";
import QuotesCarousel from "../carousels/QuotesCarousel";
import SliderPortrait from "../sliders/SliderPortrait";
import SliderLandscape from "../sliders/SliderLandscape";
import SliderLandscapeFestival from "../sliders/SliderLandscapeFestival";
import SliderStories from "../sliders/SliderStories";
import SliderCubes from "../sliders/SliderCubes";
import SliderDigital from "../sliders/SliderDigital";
import { PageModulesType, SliderItemsType } from "../types/homePageTypes";


const generatePageModules = (
  pageModulesData: PageModulesType, 
  status: boolean,
  activeSeasonFilms?: SliderItemsType[] 
): React.ReactNode => {
    let pageSections: React.ReactNode = pageModulesData.map(( section, index ) => {
      if (section.type === "slider") {
        // case 1a: banner carousel
        if (section.orientation === "carousel") {
          return (
              <BannerCarousel
                key={ index }
                title={ section.title } 
                isWebProgrammeSlider={ section.isWebProgrammeSlider }
                sliderItems={ section.sliderItems }
              />
          )
        }

        // case 1b: quotes carousel
        if (section.orientation === "quotes") {
          return (
              <QuotesCarousel
                key={ index }
                title={ section.title }
                isWebProgrammeSlider={ section.isWebProgrammeSlider }
                sliderItems={ section.sliderItems }
              />
          )
        }

        // case 1c: slider portrait
        if (section.orientation === "portrait") {
          return (
            <SliderPortrait
              key={ index }
              title={ section.title }
              description={ section.description }
              isWebProgrammeSlider={ section.isWebProgrammeSlider }
              sliderItems={ section.sliderItems }
              activeSeasonFilms={ activeSeasonFilms }
            />
          )
        }

        // case 1d: slider landscape
        if (section.orientation === "landscape") {
          return (
            <SliderLandscape
              key={ index }
              title={ section.title }
              description={ section.description }
              isWebProgrammeSlider={ section.isWebProgrammeSlider }
              sliderItems={ section.sliderItems }
            />
          )
        }

        // case 1e: slider landscape-festival
        if (section.orientation === "landscape-festival") {
          return (
            <SliderLandscapeFestival
              key={ index }
              title={ section.title }
              description={ section.description }
              isWebProgrammeSlider={ section.isWebProgrammeSlider }
              sliderItems={ section.sliderItems }
            />
          )
        }

        // case 1f: slider stories
        if (section.orientation === "stories") {
          return (
            <SliderStories
              key={ index }
              title={ section.title }
              description={ section.description }
              isWebProgrammeSlider={ section.isWebProgrammeSlider }
              sliderItems={ section.sliderItems }
            />
          )
        }

        // case 1g: slider cubes
        if (section.orientation === "cubes") {
          return (
            <SliderCubes
              key={ index }
              title={ section.title }
              description={ section.description }
              isWebProgrammeSlider={ section.isWebProgrammeSlider }
              sliderItems={ section.sliderItems }
            />
          )
        }

        // case 1h: slider digital
        if (section.orientation === "digital") {
          return (
            <SliderDigital
              key={ index }
              title={ section.title }
              description={ section.description }
              isWebProgrammeSlider={ section.isWebProgrammeSlider }
              sliderItems={ section.sliderItems }
            />
          )
        }
      }

      // case 2: Card Module
      if (section.type === "articlesSection") {

        // case: 2 cards
        if (section.version === "Version B") {
          return (
            <Cards_2
              key={ index }
              title={ section.title }  
              articleItems={ section.articleItems }
            />
          )
        }

        // case: 1 | 3 grid layout
        if (section.version === "1 | 3 Grid") {
          return (
            <Cards_1_3
              key={ index }
              title={ section.title }  
              articleItems={ section.articleItems }
            />
          )
        }

        // case: 1 | 2 | 2 grid layout
        if (section.version === "1 | 2 | 2 Grid") {
          return (
            <Cards_1_2_2
              key={ index }
              title={ section.title }  
              articleItems={ section.articleItems }
            />
          )
        }
      }
    })

    return pageSections;
}

export default generatePageModules